var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoiPlaceOfInterest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#19456B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.162 30.6181H17.5674V33.5635H14.162V30.6181ZM31.1891 30.6181H34.5945V33.5635H31.1891V30.6181ZM20.4864 19.5726H28.0269V27.6726H20.7296V19.5726H20.4864ZM14.162 13.1908H17.5674V16.1362H14.162V13.1908ZM31.1891 13.1908H34.5945V16.1362H31.1891V13.1908ZM28.0269 9.99988V16.6271H20.7296V9.99988H10.9999V19.5726H17.5674V27.4272H10.9999V36.9999H20.7296V30.8635H28.2701V36.9999H37.9999V27.4272H31.4323V19.5726H37.9999V9.99988H28.0269Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoiPlaceOfInterest);
export default __webpack_public_path__ + "static/media/poi-place-of-interest.e54b1c6e6c2e1084e073fdc0b54a86a3.svg";
export { ForwardRef as ReactComponent };